function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import MaterialTooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeStyles } from '@material-ui/core/styles';
import { capitalize } from 'swag-common/utils/strings';
import { Placement } from 'swag-client-common/constants';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { variables } from 'swag-client-common/styles/variables-js';
import CSSclasses from './tooltip.scss';
const styles = {
  tooltip: {
    fontSize: '13px',
    backgroundColor: '#393939',
    color: variables.colorWhite,
    padding: '10px 15px',
    borderRadius: '5px',
    letterSpacing: '0',
    position: 'relative',
    zIndex: 3
  }
};
const lightStyles = {
  tooltip: CSSclasses.lightTooltip,
  tooltipPlacementBottom: CSSclasses.bottomLight,
  tooltipPlacementTop: CSSclasses.topLight,
  tooltipPlacementLeft: CSSclasses.leftLight,
  tooltipPlacementRight: CSSclasses.rightLight
};
export function Tooltip(props) {
  var _props$styles;
  const [open, setIsOpen] = useState(false);
  const {
    title,
    arrow = false,
    children = {},
    placement = Placement.BOTTOM,
    disableHoverListener = false,
    className = '',
    mode = 'dark',
    interactive,
    dataBlock = '',
    placementClassName = ''
  } = props;
  const useStyles = makeStyles({
    tooltip: _objectSpread({}, styles.tooltip, ((_props$styles = props.styles) === null || _props$styles === void 0 ? void 0 : _props$styles.tooltip) || {}),
    popper: {}
  });
  const classes = useStyles();
  const handleMouseEnter = useCallback(() => {
    const isMobileMode = isMobile();
    if (isMobileMode || disableHoverListener) {
      return;
    }
    setIsOpen(true);
  }, [disableHoverListener, setIsOpen]);
  const handleMouseLeave = useCallback(() => {
    const isMobileMode = isMobile();
    if (isMobileMode || disableHoverListener) {
      return;
    }
    setIsOpen(false);
  }, [disableHoverListener, setIsOpen]);
  const handleClick = useCallback(isClickOutside => {
    const isMobileMode = isMobile();
    if (!isMobileMode) {
      return;
    }
    setIsOpen(!isClickOutside);
  }, [disableHoverListener, setIsOpen]);
  const handleBlur = useCallback(() => {
    const isMobileMode = isMobile();
    if (isMobileMode) {
      return;
    }
    setIsOpen(false);
  }, [setIsOpen]);
  const arrowClasses = useMemo(() => {
    if (!arrow) {
      return {};
    }
    return {
      arrow: CSSclasses[`arrowWrapper${capitalize(placement)}`]
    };
  }, [arrow, placement]);
  const modeStyles = useMemo(() => {
    var _props$classes, _props$classes2;
    const arrowStyles = {};
    if (arrow) {
      arrowStyles[`tooltipPlacement${capitalize(placement)}`] = null;
    }
    return mode === 'light' ? _objectSpread({}, lightStyles, arrowStyles, {
      popper: ((_props$classes = props.classes) === null || _props$classes === void 0 ? void 0 : _props$classes.popper) || classes.popper || '',
      tooltip: `${lightStyles.tooltip} ${classes.tooltip || ''} ${((_props$classes2 = props.classes) === null || _props$classes2 === void 0 ? void 0 : _props$classes2.tooltip) || ''}`
    }) : {};
  }, [arrow, placement]);
  const otherTooltipProps = {};
  if (!interactive || isMobile()) {
    otherTooltipProps.open = open;
  }
  return /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: () => handleClick(true)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MaterialTooltip, _extends({
    "data-block": dataBlock,
    arrow: arrow,
    title: title || '',
    placement: placement,
    interactive: interactive,
    classes: _objectSpread({
      tooltipPlacementBottom: classNames(CSSclasses.bottom, placementClassName),
      tooltipPlacementTop: classNames(CSSclasses.top, placementClassName),
      tooltipPlacementLeft: classNames(CSSclasses.left, placementClassName),
      tooltipPlacementRight: classNames(CSSclasses.right, placementClassName)
    }, classes, arrowClasses, modeStyles),
    disableHoverListener: disableHoverListener
  }, otherTooltipProps), /*#__PURE__*/React.createElement("div", {
    className: className,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onBlur: handleBlur,
    onClick: () => handleClick(false)
  }, children))));
}